import { render, staticRenderFns } from "./AllPhotos.vue?vue&type=template&id=79deb349"
import script from "./AllPhotos.vue?vue&type=script&lang=js"
export * from "./AllPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports